/*
  h26-hg.js: The Harvest Guarantee product page (section h26-hg-main). Loaded only there.

  1. Options: the "Choose your membership" radios are the form's `id` field, so the add to cart
     (assets/h26-atc.js) always posts the checked option. On change this updates, from the
     variants JSON the section prints (prices are formatted by Shopify, never here): the price,
     the struck compare-at and its line, places left and the bar, the button label and its
     sold-out state, and the URL's ?variant=.
  2. One place per order: before h26-atc.js sees the submit (window capture runs first), the
     cart is checked from a copy read on load and after each add. If any option of this
     product is already in the cart, the add is stopped, the cart opens and data-msg-one shows.
     If the cart was never read, the add goes ahead (the store-side limit is the real guard).
  3. Gallery dots (only when the product has two or more photos).
  Never throws; with no JS the form still adds the checked option.
*/
(function () {
  'use strict';
  if (window.__h26g) return;
  window.__h26g = true;

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  function setupBuy(root) {
    var buy = root.querySelector('[data-h26g-buy]');
    if (!buy) return;
    var data = [];
    try { data = JSON.parse(buy.querySelector('[data-h26g-variants]').textContent); } catch (e) { data = []; }
    var byId = {};
    data.forEach(function (v) { byId[String(v.id)] = v; });
    var total = parseInt(buy.getAttribute('data-total'), 10) || 100;
    var btnTpl = buy.getAttribute('data-btn-tpl') || '{price}';
    var worthTpl = buy.getAttribute('data-worth-tpl') || '';
    var soldLabel = buy.getAttribute('data-soldout') || '';
    var form = buy.querySelector('form[data-h26-atc]');
    var btn = buy.querySelector('[data-h26g-btn]');
    var now = buy.querySelector('[data-h26g-now]');
    var was = buy.querySelector('[data-h26g-was]');
    var worth = buy.querySelector('[data-h26g-worth]');
    var places = buy.querySelector('[data-h26g-places]');
    var leftEl = buy.querySelector('[data-h26g-left]');
    var bar = buy.querySelector('[data-h26g-bar]');
    var productId = String(root.getAttribute('data-product-id') || '');

    function render(v) {
      if (!v) return;
      if (now) now.textContent = v.price;
      if (was) { was.textContent = v.was || ''; was.hidden = !v.was; }
      if (worth) { worth.textContent = v.was ? worthTpl.replace('{compare}', v.was) : ''; worth.hidden = !v.was || !worthTpl; }
      if (places) {
        places.hidden = !v.tracked;
        if (leftEl) leftEl.textContent = String(v.left);
        if (bar) bar.style.width = (Math.round((total - v.left) * 1000 / total) / 10) + '%';
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btnTpl.replace('{price}', v.price) : soldLabel;
      }
      // Oct 16 (review GEM-1-06): the math table follows the picked option.
      each(document.querySelectorAll('[data-h26g-math-v]'), function (tb) { tb.hidden = tb.getAttribute('data-h26g-math-v') !== String(v.id); });
      each(buy.querySelectorAll('.h26g-opt'), function (lab) {
        var inp = lab.querySelector('input');
        lab.classList.toggle('is-on', !!(inp && inp.checked));
      });
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
    }

    buy.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'id' || t.type !== 'radio') return;
      render(byId[String(t.value)]);
    });
    var checked = buy.querySelector('input[name="id"]:checked');
    if (checked) render(byId[String(checked.value)]);

    // one place per order
    var cart = null;
    function readCart() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && c.items) cart = c; })
        .catch(function () {});
    }
    function inCart() {
      if (!cart || !productId) return false;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].product_id) === productId) return true;
      }
      return false;
    }
    readCart();
    if (form) {
      form.addEventListener('h26:atc', function () { readCart(); });
      // Review GPT-1-04 (Oct 16): the cart is re-read before blocking, so a place removed in the drawer
      // since the page loaded doesn't keep the button blocked; a fresh "not in cart" re-submits.
      var recheck = false;
      function block() {
        var msg = form.querySelector('[data-h26-msg]');
        if (msg) { msg.textContent = form.getAttribute('data-msg-one') || ''; msg.hidden = !msg.textContent; }
        form.setAttribute('data-h26g-state', 'one');
        try { if (window.OOH26 && window.OOH26.track) window.OOH26.track('atc_result', { outcome: 'one_per_order', source: 'h26-hg-main' }, form); } catch (err) {}
        try { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); } catch (err) {}
      }
      window.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (recheck) { recheck = false; return; }
        if (!inCart()) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        readCart().then(function () {
          if (inCart()) { block(); return; }
          var msg = form.querySelector('[data-h26-msg]');
          if (msg) { msg.textContent = ''; msg.hidden = true; }
          form.removeAttribute('data-h26g-state');
          recheck = true;
          try { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); } catch (err) { recheck = false; }
        });
      }, true);
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') readCart(); });
      // Review GEM-1-07: when UpCart's drawer closes (the event h26-shared.js uses; 'cart-updated' too, if UpCart
      // sends it) the cache refreshes and the "one place" message clears once the Guarantee has left the cart.
      function afterDrawer() {
        readCart().then(function () {
          if (inCart() || form.getAttribute('data-h26g-state') !== 'one') return;
          form.removeAttribute('data-h26g-state');
          var msg = form.querySelector('[data-h26-msg]');
          if (msg) { msg.textContent = ''; msg.hidden = true; }
        });
      }
      window.addEventListener('aftersell-upcart:public-events:cart-closed', afterDrawer);
      window.addEventListener('aftersell-upcart:public-events:cart-updated', afterDrawer);
      window.addEventListener('pageshow', function (e) { if (e.persisted) readCart(); });
    }
  }

  function setupGallery(root) {
    var track = root.querySelector('[data-h26g-track]');
    var dots = root.querySelectorAll('[data-h26g-go]');
    if (!track || !dots.length) return;
    each(dots, function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-h26g-go'), 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });
    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        each(dots, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }, 80);
    });
  }

  function init() {
    each(document.querySelectorAll('[data-h26g-main]'), function (root) {
      try { setupBuy(root); } catch (e) {}
      try { setupGallery(root); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
